import lang from "../../lang";
const language = localStorage.getItem("language")
const customChar = (char, options = {}) => {
  const { name = null, width = 20 } = options;
  return { [char]: { key: char, text: name || char, width } };
};

const predefined = {
  rows: {
    suggestedEmail:
      (process.env.NODE_ENV === "development" ? "@mdware.org " : "") +
      "@gmail.com @hotmail.com @hotmail.be @outlook.com @outlook.be ",
    bottom: "{nums} {space} {accept}",
  },
  layouts: {
    default: [
      "a z e r t y u i o p {backspace}",
      "q s d f g h j k l m",
      "{shiftl} w x c v b n @ . {shiftr}",
      "{nums} {space} {accept}",
    ],
    shifted: [
      "A Z E R T Y U I O P {backspace}",
      "Q S D F G H J K L M",
      "{shiftl} W X C V B N @ . {shiftr}",
      "{nums} {space} {accept}",
    ],
  },
  _meta: {
    tab: { key: "\t", text: "Tab", width: 60, classes: "control" },

    default: {
      keySet: "default",
      text: "ABC",
      width: 50,
      classes: "control",
    },
    nums: { keySet: "nums", text: ".?123", width: 50, classes: "control" },
    nums_ext: {
      keySet: "extended",
      text: "#+=",
      width: 50,
      classes: "control",
    },
    shiftl: {
      keySet: "shifted",
      text: "Shift",
      width: 50,
      classes: "control",
    },
    shiftr: {
      keySet: "shifted",
      text: "Shift",
      width: 50,
      classes: "control",
    },
    caps: { keySet: "capsed", text: "Caps", width: 80, classes: "control" },

    space: { key: " ", text: "", width: 180 },
    enter: { key: "\r\n", text: lang["enter"][language], width: 80, classes: "control" },
    backspace: { func: "backspace", classes: "control backspace", width: 65 },

    accept: {
      func: "accept",
      width: 30,
      classes: "control featured",
    },
    next: { func: "next", text: "Volgende", classes: "control featured" },

    dot: { key: ".", text: ".", width: 20 },
    dot_com: { key: ".com", text: ".com", width: 20 },
    dot_be: { key: ".be", text: ".be", width: 20 },

    ...customChar("-"),
    ...customChar("_"),
    ...customChar("!"),
    ...customChar("?"),
    ...customChar("^"),
    ...customChar("*"),
  },
};

export const layouts = {
  // kiosk email without pre defined emails
  kiosk: {
    _meta: predefined._meta,

    default: [
      "a z e r t y u i o p {backspace}",
      "q s d f g h j k l m ",
      "{shiftl} w x c v b n @ . {shiftr}",
      predefined.rows.bottom,
    ],

    shifted: [
      "A Z E R T Y U I O P {backspace}",
      "Q S D F G H J K L M",
      "{shiftl} W X C V B N @ . {shiftr}",
      predefined.rows.bottom,
    ],

    nums: [
      "1 2 3 4 5 6 7 8 9 0 {backspace}",
      "` | { } $ % ^ * / '",
      "{nums_ext} {_} {-} & ~ # = + . {nums_ext}",
      "{default} {space} {accept}",
    ],

    extended: [
      '[ ] { } ‹ › ^ * " , {backspace}',
      "` | { } $ % ^ * / '",
      "{nums} {_} {-} & ~ # = + . {nums}",
      "{default} {space} {accept}",
    ],

    // capsed: [
    //     "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
    //     "{tab} Q W E R T Y U I O P [ ] \\",
    //     "{caps} A S D F G H J K L ; ' {enter}",
    //     "{shiftl} Z X C V B N M , . / {shiftr}",
    //     "{next} {space} {accept}"
    // ]
  },
  // kiosk email with pre devined emails
  kiosk_email: {
    _meta: predefined._meta,

    default: [
      "a z e r t y u i o p {backspace}",
      "q s d f g h j k l m",
      "{shiftl} w x c v b n @ . {shiftr}",
      predefined.rows.bottom,
      predefined.rows.suggestedEmail,
    ],

    shifted: [
      "A Z E R T Y U I O P {backspace}",
      "Q S D F G H J K L M",
      "{shiftl} W X C V B N @ . {shiftr}",
      predefined.rows.bottom,
      predefined.rows.suggestedEmail,
    ],

    nums: [
      "1 2 3 4 5 6 7 8 9 0 {backspace}",
      "` | { } $ % ^ * / '",
      "{nums_ext} {_} {-} & ~ # = + . {nums_ext}",
      "{default} {space} {accept}",
    ],

    extended: [
      '[ ] { } ‹ › ^ * " , {backspace}',
      "` | { } $ % ^ * / '",
      "{nums} {_} {-} & ~ # = + . {nums}",
      "{default} {space} {accept}",
    ],

    // capsed: [
    //     "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
    //     "{tab} Q W E R T Y U I O P [ ] \\",
    //     "{caps} A S D F G H J K L ; ' {enter}",
    //     "{shiftl} Z X C V B N M , . / {shiftr}",
    //     "{next} {space} {accept}"
    // ]
  },
  kiosk_numeric: {
		_meta: {
			"backspace": { func: "backspace", classes: "control"},
      "accept": { func: "accept", classes: "control featured" },
			// "next": { func: "next", text: "Next", classes: "control featured"},
      "zero": { key: "0", width: 100 }
		},

    default: [
      "1 2 3",
      "4 5 6",
      "7 8 9",
      "{accept} {zero} {backspace}"
    ]
  }

};
